<template>
    <a :key="possibleLangPrefix" :href="`${possibleLangPrefix}`" class="uppercase text-gray-200 font-bold tracking-[3px] text-sm do-not-translate leading-none">
        Pure <br>
        Pascale
    </a>
</template>
    
<script>
export default {
    name: 'logo',

    computed: {
        possibleLangPrefix() {
            // prefix with lang other than nl for correct Weglot translations
            return document.documentElement.lang !== 'nl' ? `/${document.documentElement.lang}` : '/';
        },
    },
}
</script>
    